import { render, staticRenderFns } from "./Personnelscore.vue?vue&type=template&id=4ccf8581&scoped=true&"
import script from "./Personnelscore.vue?vue&type=script&lang=js&"
export * from "./Personnelscore.vue?vue&type=script&lang=js&"
import style0 from "./Personnelscore.vue?vue&type=style&index=0&id=4ccf8581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf8581",
  null
  
)

export default component.exports